import { render, staticRenderFns } from "./UserCardState.vue?vue&type=template&id=0fae0cc4&scoped=true"
import script from "./UserCardState.vue?vue&type=script&lang=ts"
export * from "./UserCardState.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fae0cc4",
  null
  
)

export default component.exports